<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="ch00_fm03_title"><a id="page_iii"></a>Helen Keller</h1>
<p class="author1"><span class="fontbl"><em>Selected Writings</em></span></p>
<p class="author1">Edited by<br/><span class="fontb">KIM E. NIELSEN</span></p>
<p class="author1a">Consulting Editor: Harvey J. Kaye</p>
<p class="pub"><img alt="image" src="images/pub.jpg"/></p>
<p class="pub"><img alt="image" src="images/pub1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?8ceac792